import React from 'react';
import {Mixin as FormsyMixin} from 'formsy-react';
import ComponentMixin from 'formsy-react-components/release/mixins/component';
import {Row} from 'formsy-react-components';
import LoadingButton from './LoadingButton.react';

// eslint-disable-next-line
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

let ActionButton = React.createClass({
	displayName: 'ActionButton',

	mixins: [FormsyMixin, ComponentMixin],

    render: function render() {
        if (this.getLayout() === 'elementOnly') {
            return this.renderElement();
        }

        return React.createElement(
            Row,
            _extends({}, this.getRowProperties(), {
                htmlFor: this.getId()
            }),
            this.renderElement(),
            this.renderHelp(),
            this.renderErrorMessage()
        );
    },

    /**
     * @override Select.renderElement
     */
    renderElement: function renderElement() {
        let passProps = JSON.parse(JSON.stringify(this.props));
        delete passProps.id;
        delete passProps.value;
        delete passProps.onChange;
        delete passProps.disabled;
        delete passProps.label;

        return (<div
            disabled={this.isFormDisabled() || this.props.disabled}
            id={this.getId()}
            {...passProps}
        ><LoadingButton className="btn btn-default" onClick={() => this.props.onClick() } title={this.props.label} /></div>);
    }

});

export default ActionButton;
